module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gb-Hb-Ia.558a18e9.png";